import { useRuta } from '../lib/ruta';
import { Icono } from '../componentes/ui/Icono';
import { AvisoPrivacidad, GRUPOS_MENU, rutaDe } from '../componentes/navegacion/Navegacion';

/** Menú completo para el móvil. */
export function Mas() {
  const { ir } = useRuta();
  return (
    <div className="stack-lg">
      <header><p className="eyebrow">Todo mi universo</p><h1 className="display">Más</h1></header>
      {GRUPOS_MENU.map((g) => (
        <section key={g.titulo} className="stack-sm">
          <h2 className="eyebrow">{g.titulo}</h2>
          <div className="grid2">
            {g.entradas.map((e) => (
              <button key={e.id} className="listbtn" onClick={() => ir(rutaDe(e.id))} style={{ flexDirection: 'row', alignItems: 'center', gap: 12 }}>
                <span className="qicon"><Icono nombre={e.icono} /></span>
                <span style={{ fontWeight: 600 }}>{e.etiqueta}</span>
              </button>
            ))}
          </div>
        </section>
      ))}
      <AvisoPrivacidad />
    </div>
  );
}
